import { useEffect } from 'react';

/**
 * Empêche la navigation arrière accidentelle sur les pages de jeu :
 *  - Geste swipe-back (iOS Safari, Chrome Android)
 *  - Touche Backspace hors d'un champ de saisie (comportement navigateur desktop)
 *
 * Mécanisme : on pousse une entrée fantôme dans l'historique avec la même URL
 * courante. Si l'utilisateur déclenche "précédent", le navigateur revient sur
 * cette entrée fantôme (même URL → pas de changement de route React Router) et
 * on en repousse immédiatement une nouvelle pour maintenir la protection.
 */
const useBackGuard = () => {
  useEffect(() => {
    window.history.pushState(null, '');

    const handlePopState = () => {
      window.history.pushState(null, '');
    };

    const handleKeyDown = (e) => {
      if (
        e.key === 'Backspace' &&
        !['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName) &&
        !e.target.isContentEditable
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};

export default useBackGuard;
